export const SHORTCUT_PRODUCT_OFFER = `
  id
  price
  oldPrice
  salePeriod {
    start
    finish
  }
  min
  max
  step
  quant
  quantAmount
  uiQuant
  isDefault
  group
  count_multiplier @client
`

export const SHORTCUT_PRODUCT_OFFERS = `
  priceOffers {
    ${SHORTCUT_PRODUCT_OFFER}
  }
`

export const SHORTCUT_PRODUCT_SHOP_INFO = `
  stock {
    amount
  }
  priceOffer @client {
    ${SHORTCUT_PRODUCT_OFFER}
  }
  ${SHORTCUT_PRODUCT_OFFERS}
`

export const SHORTCUT_PRODUCT_CARD_FIELDS = `
  id
  xid
  name
  price_type

  weight
  weight_netto
  weight_multiplier

  pkg

  brand {
    id
    name
  }

  preview(style: $style) {
    url
  }
    
  review_count
  average_rating
  is_alcohol
  isFavorite
  isWeightProduct

  marketingLabels {
    id
    title
    image(style: "600xauto") {
      url
    }
  }

  timeRestrictions {
    from
    to
  }
  ${SHORTCUT_PRODUCT_SHOP_INFO}
`

export const SHORTCUT_PRODUCT_FIELDS = `
  id
  xid
  name
  slug

  price_type

  weight
  weight_netto
  weight_multiplier

  w
  h
  l
  pkg

  brand {
    id
    name
  }

  preview(style: $style) {
    url
  }
  isWeightProduct
  marketingLabels {
    id
    title
    description
    image(style: "600xauto") {
      url
    }
    activeFrom
    activeUntil
    optionColor
    optionBackgroundColor
    optionLink
    optionLinkLabel
  }
  review_count
  average_rating
  is_alcohol

  timeRestrictions {
    from
    to
  }
`

export const SHORTCUT_PRODUCT_ATTRIBUTES = `
  attributes {
    name
    value
  }
`
